export default __webpack_public_path__ + "static/media/phone.718a8f5d.png";